import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { useRef, useState } from "react";

import styled from "styled-components/macro";

import { faLink } from "@fortawesome/pro-solid-svg-icons";

import FnrButton from "UI/FnrButton3";
import { FnrPopover } from "UI/FnrPopover2";

import { addHttpToUrl } from "Utilities/addHttpToUrl";
import validateUrl from "Utilities/validateUrl";

import { MenuButton } from "../styles";

LinkButton.propTypes = {
  editor: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

export default function LinkButton({ editor, disabled = false }) {
  const buttonRef = useRef();
  const inputRef = useRef();
  const [showPopover, setShowPopover] = useState(false);
  const [linkVal, setLinkVal] = useState("");
  const [showInvalidMsg, setShowInvalidMsg] = useState(false);

  const handleMenuButtonClick = () => {
    const previousUrl = editor.getAttributes("link").href;
    setLinkVal(previousUrl || "");
    setShowPopover(true);

    setTimeout(() => {
      inputRef?.current?.focus();
    }, 250);
  };

  const handleInsertLinkClick = (e) => {
    if (e) e.preventDefault();

    if (linkVal.trim() === "") {
      editor.chain().focus().extendMarkRange("link").unsetLink().run();
    }

    const urlWithHttp = addHttpToUrl(linkVal);
    const isValid = validateUrl(urlWithHttp);

    if (isValid) {
      editor
        .chain()
        .focus()
        .extendMarkRange("link")
        .setLink({ href: urlWithHttp })
        .run();

      setShowPopover(false);
    } else {
      setShowInvalidMsg(true);
      setShowPopover(true);
    }
  };

  return (
    <>
      <MenuButton
        ref={buttonRef}
        onClick={handleMenuButtonClick}
        className={editor.isActive("link") || showPopover ? "is-active" : ""}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={faLink} />
      </MenuButton>

      <FnrPopover
        buttonRef={buttonRef}
        show={showPopover}
        onShouldClose={() => setShowPopover(false)}
      >
        <PopoverContent onClick={(e) => e.stopPropagation()}>
          {showInvalidMsg ? (
            <>
              <InvalidMsg>
                Oops! It doesn&apos;t look like that is a valid URL. Please
                double-check the link and try again.
              </InvalidMsg>
              <FnrButton color="blue" onClick={() => setShowInvalidMsg(false)}>
                OK
              </FnrButton>
            </>
          ) : (
            <form onSubmit={handleInsertLinkClick}>
              <div>
                <Label>Link selected text to:</Label>
                <LinkInput
                  ref={inputRef}
                  placeholder="http://www.example.com"
                  value={linkVal}
                  onChange={(e) => setLinkVal(e.target.value)}
                />
              </div>
              <ButtonWrapper>
                <FnrButton onClick={() => setShowPopover(false)} type="button">
                  Cancel
                </FnrButton>
                <FnrButton color="blue" onClick={handleInsertLinkClick}>
                  Insert Link
                </FnrButton>
              </ButtonWrapper>
            </form>
          )}
        </PopoverContent>
      </FnrPopover>
    </>
  );
}

const PopoverContent = styled.div`
  width: 280px;
  padding: 10px;
`;

const Label = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: white;
  margin-bottom: 2px;
`;

const LinkInput = styled.input`
  box-sizing: border-box;
  display: block;
  width: 100%;
  font-size: 16px;
  padding: 10px;
  border-radius: 6px;
  border: none;
  margin-bottom: 10px;
  font-weight: 400;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const InvalidMsg = styled.div`
  font-weight: 400;
  font-size: 17px;
  color: white;
  margin-bottom: 5px;
`;
